import React, { useEffect } from "react";
import useAnimation from "../../../../../services/functions/useAnimation";
import useFetch from "../../../../../services/functions/useFetch";
import snowflake from "../../../../../assets/icons/loading-snowflake.svg";
import CustomAlert from "../../../../CustomAlert";
import { Exercise } from "../../ContentList";

interface PopupSettings {
    popup: {
        index: number;
        title: string;
        visible: boolean;
    };
    setPopup: React.Dispatch<React.SetStateAction<{
        index: number;
        title: string;
        visible: boolean;
    }>>;
    exerciseList: Exercise[];
    setExerciseList: React.Dispatch<React.SetStateAction<Exercise[]>>;
}

const Popup: React.FC<PopupSettings> = ({ popup, setPopup, exerciseList, setExerciseList }) => {
    const NavBarHeight = 50; // Adjust this value as needed
    const { slideOutItem } = useAnimation();
    const { error, isPending, fetchData } = useFetch();

    const resetPopup = () => {
        setPopup({ index: -1, title: "", visible: false });
    }

    const handleDelete = (id: string | null) => {
        if (!id) {
            console.error("Failed to delete exercise. Invalid ID!");
            return;
        }

        const payload = {
            id: Number(id),
        };

        fetchData(`/delete/exercise`, "DELETE", {
            body: payload,
            doOnSuccess: () => {
                let localExercises = exerciseList;
                localExercises = localExercises.filter((ex) => ex.id !== parseInt(id));
                setExerciseList(localExercises);
            },
            doOnError: () => {
                console.error("Failed to delete exercise.");
            },
        });
    };


    return (
        <>
            {error && <CustomAlert message={error} type="error" />}
            {isPending ? (
                <img src={snowflake} alt="loading" className="loading-snowflake" />
            ) : (
                <div
                    style={{
                        paddingTop: `${NavBarHeight}px`,
                        position: "fixed",
                        inset: 0,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        backgroundColor: "hsla(0, 5.90%, 10.00%, 0.53)",
                        zIndex: 40,
                    }}
                    role="presentation"
                    onClick={() => resetPopup()}
                >
                    <section className="section-container">
                        <div className="content-wrapper">
                            <div className="form-container"
                                onClick={(e) => e.stopPropagation()}
                                style={{ textAlign: "center" }}>
                                <h1 className="form-title"
                                    style={{
                                        borderBottom: "2px solid #3bd2e5e0",
                                        paddingBottom: "1rem",
                                        marginBottom: "1rem",
                                        userSelect: "none"
                                    }}>
                                    Bestätigung
                                </h1>
                                <form className="form" noValidate>
                                    <h2 className="form-label">
                                        Willst du die Übung <span style={{fontWeight: "600"}}>
                                            {popup.title}
                                        </span> wirklich löschen?
                                    </h2>
                                    <div style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        paddingTop: "1rem",
                                        gap: "2rem",
                                    }}>
                                        <button className="form-button"
                                            onClick={async () => {
                                                if (popup.index >= 0) {
                                                    await slideOutItem(".card__wrapper", popup.index.toString());
                                                    setTimeout(() => handleDelete(popup.index.toString()), 400);
                                                }   
                                                resetPopup();
                                            }}
                                        >
                                            Löschen
                                        </button>
                                        <button className="form-button"
                                            onClick={() => resetPopup()}
                                        >
                                            Abbrechen
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </section>
                </div>
            )}
        </>
    );
};

export default Popup;
